<script setup lang="ts">
import { computed, reactive, ref, onMounted, watch } from 'vue'
import { closeDialog } from 'vue3-promise-dialog'

import { storeToRefs } from 'pinia'
import ObuBookingContractorMask from '@/modules/obu_booking/_components/Shared/ObuBookingContractorMask.vue'
import type { IKeyValueMulitTypeStore } from '@/types'

import { useContactStore } from '@/pinia/ContactStore.js'
import { useGlobalStore } from '@/pinia/GlobalStore.js'
import { promiseTimeout } from '@vueuse/core'

export interface Props {
  open: boolean,
  contactId?: number | null
  title?: string
}

const formRef = ref()
const isSaving = ref(false)
const errors = computed(() => formRef.value?.errors || null)

const props = withDefaults(defineProps<Props>(), {
  contactId: null,
  title: 'Kontakt bearbeiten'
})

const contactStore = useContactStore()
const globalStore = useGlobalStore()

const { contactEdit } = storeToRefs(contactStore)
const form = reactive(contactEdit.value)
const isReady = ref(false)

onMounted(async () => {
  await globalStore.loadParams(['salutations', 'countries'])
  if (props.contactId) {
    await contactStore.find(props.contactId)
  }
  isReady.value = true
})

watch(contactEdit, async () => {
  await promiseTimeout(500)
  formRef.value.setValues(contactEdit.value)
})

const onClose = () => {
  closeDialog(false)
}

const onSuccess = async (values: IKeyValueMulitTypeStore) => {
  await contactStore.save(values)
  closeDialog(contactEdit.value)
}

</script>

<template>
  <storm-ui-dialog
    :title="title"
    width="lg"
    :show="true"
    height="auto"
    :initial-values="contactStore.add()"
    @hide="onClose"
  >
    <template #content>
      <storm-ui-form
        v-if="isReady"
        id="contact-form"
        ref="formRef"
        :initial-values="form"
        @success="onSuccess"
        @request="isSaving = true"
      >
        <storm-ui-form-errors
          :errors="errors"
        />
        <ObuBookingContractorMask />
      </storm-ui-form>
    </template>
    <template #footer>
      <div class="flex text-right items-center space-x-2">
        <storm-ui-button
          type="button"
          variant="link"
          @click="onClose"
        >
          Abbrechen
        </storm-ui-button>
        <storm-ui-button
          type="submit"
          variant="primary"
          form="contact-form"
        >
          Speichern
        </storm-ui-button>
      </div>
    </template>
  </storm-ui-dialog>
</template>
